import { Fragment, ReactElement, useMemo } from 'react';
import { getBaseUrl } from '../../get-base-url';
import { useParams } from 'react-router-dom';
import PersonSearchDeathNonResidentNotificationShared from 'shell/components/shared/research-notifications/research-death-non-resident/edit-person-search';
import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';

interface PersonSearchDeathNonResidentNotificationCivilStatusSharedProps {
  scope?: string;
  items?: BreadcrumbItem[];
}

const PersonSearchDeathNonResidentNotificationCivilStatusShared = ({
  scope,
  items,
}: PersonSearchDeathNonResidentNotificationCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idCat = params.idCat || undefined;
  const idAnsc = params.id || undefined;
  const idNotifica = params.idNotifica || '';

  const goBackUrl: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/modifica/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const redirectUrl: string = useMemo(() => {
    return `${goBackUrl}/morte/non-residenti/cancellazione/:idIntestatario/:idSchedaSoggettoANPR`;
  }, [goBackUrl]);

  return (
    <Fragment>
      <PersonSearchDeathNonResidentNotificationShared
        goBackUrl={`${goBackUrl}/morte/non-residenti`}
        redirectUrl={redirectUrl}
        items={items}
      />
    </Fragment>
  );
};

PersonSearchDeathNonResidentNotificationCivilStatusShared.displayName =
  'Research Death Non Resident Notifications Page component';

export default PersonSearchDeathNonResidentNotificationCivilStatusShared;
